/**
 * Legacy accounting error codes returned as `{ error, code, message }` by the
 * accounting endpoints (not yet migrated to RFC 7807). Mirrors the backend
 * `App\Accounting\Enums\Error`.
 */
export const AccountingErrorCode = {
  NotConfiguredForAgency: 15
} as const

export type AccountingErrorCode =
  (typeof AccountingErrorCode)[keyof typeof AccountingErrorCode]
